import React, { type FC } from 'react';
import type { IAlbum } from 'reactApp/modules/albums/albums.types';
import { Album } from 'reactApp/ui/Album/Album';
import { AlbumsLayout } from 'reactApp/ui/AlbumsLayout/AlbumsLayout';
import { CreateAlbum } from 'reactApp/ui/CreateAlbum/CreateAlbum';
import { ErrorRetry } from 'reactApp/ui/ErrorRetry/ErrorRetry';
import { Spinner } from 'reactApp/ui/Spinner/Spinner';

import styles from './AlbumsGrid.css';

export interface AlbumsGridProps {
    albums: IAlbum[];
    showCreateButton?: boolean;
    disableCreateButton?: boolean;
    handleCreateClick?: () => void;
    createButtonText?: string;
    isLoading?: boolean;
    isError?: boolean;
    qaTitle?: string;
}

export const AlbumsGrid: FC<AlbumsGridProps> = ({
    albums,
    showCreateButton = true,
    disableCreateButton = false,
    createButtonText = 'Создать альбом',
    handleCreateClick,
    isLoading = false,
    isError = false,
    qaTitle,
}) => {
    if (isError) {
        return <ErrorRetry centered />;
    }

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <AlbumsLayout qaTitle={qaTitle}>
            {showCreateButton && (
                <div className={styles.album} key="create-new-album">
                    <CreateAlbum onClick={handleCreateClick} disabled={disableCreateButton} text={createButtonText} />
                </div>
            )}
            {albums.map((item) => (
                <Album key={item.id} {...item} />
            ))}
        </AlbumsLayout>
    );
};
